// extracted by mini-css-extract-plugin
module.exports = {"award":"award-zabrze-module--award--2dX1N"};